module.exports = __webpack_public_path__ + "media/images/hero_images/brand-1500-95a40b8af9276afc76549c30fa6fe1ff.jpg";